import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DealersAddressDetail from './components/DealersAddressDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageDealersAddress',
  components: {
    DealersAddressDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;